import { ActionType, FiltersSelectorState } from "../Interfaces"
import { getThreeMonthsBefore, getYesterday } from "../../../helpers/temporal"

export interface DateRange {
	from: Date
	to: Date
}

export const initialState: FiltersSelectorState = {
	channels: [{ code: "0", name: "All" }],
	formats: [{ code: "0", name: "All" }],
	regions: [{ code: "0", name: "All" }],
	counties: [{ code: "0", name: "All" }],
	stores: [{ code: "0", name: "All" }],
	vendors: [{ code: "0", name: "All" }],
	brands: [{ code: "0", name: "All" }],
	departments: [{ code: "0", name: "All" }],
	categories: [{ code: "0", name: "All" }],
	subcategories: [{ code: "0", name: "All" }],
	fineline: [{ code: "0", name: "All" }],
	products: [{ code: "0", name: "All" }],
	dateRange: { from: getThreeMonthsBefore(), to: getYesterday() },
}

export interface Actions {
	SET_CHANNEL: string
	SET_FORMAT: string
	SET_REGION: string
	SET_COUNTY: string
	SET_STORE: string
	SET_DATE_RANGE: string
	SET_VENDORS: string
	SET_BRANDS: string
	SET_CATEGORIES: string
	SET_SUBCATEGORIES: string
	SET_DEPARTMENT: string
	SET_FINELINE: string
	SET_PRODUCTS: string
	SET_FILTERS: string
	RESET_FILTERS: string
}

export const FiltersSelectorActions: Actions = {
	SET_CHANNEL: "SET_CHANNEL",
	SET_FORMAT: "SET_FORMAT",
	SET_REGION: "SET_REGION",
	SET_COUNTY: "SET_COUNTY",
	SET_STORE: "SET_STORE",
	SET_DATE_RANGE: "SET_DATE_RANGE",
	SET_VENDORS: "SET_VENDORS",
	SET_BRANDS: "SET_BRANDS",
	SET_CATEGORIES: "SET_CATEGORIES",
	SET_SUBCATEGORIES: "SET_SUBCATEGORIES",
	SET_DEPARTMENT: "SET_DEPARTMENT",
	SET_FINELINE: "SET_FINELINE",
	SET_PRODUCTS: "SET_PRODUCTS",
	SET_FILTERS: "SET_FILTERS",
	RESET_FILTERS: "RESET_FILTERS",
}

export default (
	state: FiltersSelectorState = initialState,
	action: ActionType
): FiltersSelectorState => {
	const actions = FiltersSelectorActions

	const actionMapper = {
		[actions.SET_CHANNEL]: { ...state, channels: action.payload },
		[actions.SET_FORMAT]: { ...state, formats: action.payload },
		[actions.SET_REGION]: { ...state, regions: action.payload },
		[actions.SET_COUNTY]: { ...state, counties: action.payload },
		[actions.SET_STORE]: { ...state, stores: action.payload },
		[actions.SET_DATE_RANGE]: { ...state, dateRange: action.payload },
		[actions.SET_VENDORS]: { ...state, vendors: action.payload },
		[actions.SET_BRANDS]: { ...state, brands: action.payload },
		[actions.SET_CATEGORIES]: { ...state, categories: action.payload },
		[actions.SET_SUBCATEGORIES]: { ...state, subcategories: action.payload },
		[actions.SET_DEPARTMENT]: { ...state, departments: action.payload },
		[actions.SET_FINELINE]: { ...state, fineline: action.payload },
		[actions.SET_PRODUCTS]: { ...state, products: action.payload },
		[actions.SET_FILTERS]: { ...state, ...action.payload },
		[actions.RESET_FILTERS]: initialState,
	}

	return actionMapper[action.type] || state
}
